import { render, staticRenderFns } from "./ShareBySms.vue?vue&type=template&id=08630a12&lang=pug&"
import script from "./ShareBySms.vue?vue&type=script&lang=js&"
export * from "./ShareBySms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports